import domready from 'domready'
import HeroSliderController from './controllers/hero-slider-controller'

export default function initStoryController () {
  domready(() => {
    const element = document.querySelector('.hero-slider')
    if (element) {
      // eslint-disable-next-line no-new
      new HeroSliderController(element)
    }
  })
}
